import { RouteProperties } from '../types/RouteProperties'
import { Task } from 'pages/Task'
import { Oops } from 'pages/Oops'

const routes: RouteProperties[] = [
  {
    component: Task,
    exact: true,
    path: '/task/:id',
    permission: [
      'role.agency-primary-manager',
      'role.agency-manager',
      'role.client-primary-manager',
      'role.client-manager',
      'role.account-manager',
      'role.admin',
      'role.supervisor',
    ],
  },
  {
    component: Oops,
    exact: true,
    path: '/oops',
  },
]

export default routes
